import { useState, useEffect, useCallback, useRef } from "react";
import { NotifPanel } from "./SharedUI";

function Header({ page, notifs, onNotifRead, setPage }) {
  const [notifOpen, setNotifOpen] = useState(false);
  const notifRef = useRef(null);
  const unread = notifs.filter((n) => !n.read).length;

  const [theme, setTheme] = useState(() => {
    try {
      const t = localStorage.getItem("theme");
      if (t) return t;
      return window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: light)").matches
        ? "light"
        : "dark";
    } catch (e) {
      return "dark";
    }
  });

  useEffect(() => {
    try {
      const root = document.documentElement;
      if (theme === "light") root.classList.add("light-theme");
      else root.classList.remove("light-theme");
      localStorage.setItem("theme", theme);
    } catch (e) {
      // ignore
    }
  }, [theme]);

  useEffect(() => {
    const h = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target))
        setNotifOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const titles = {
    dashboard: ["Dashboard", "Operational Overview"],
    customers: ["Customers", "Customer Management"],
    orders: ["Orders", "Order Management"],
    collection: ["Collection", "Accounts Receivable"],
    reporting: ["Reporting", "Analytics & Reports"],
    inventory: ["Inventory", "Stock Management"],
    deliveries: ["Deliveries", "Delivery Schedule"],
    accounts: ["Accounts", "Credit & Account Management"],
  };
  const [title, crumb] = titles[page] || ["CRM", ""];

  return (
    <div className="hdr">
      <div className="hdr-info">
        <div className="hdr-title">{title}</div>
        <div className="hdr-crumb">
          GasCRM · {crumb} ·{" "}
          {new Date().toLocaleDateString("en-ZA", {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </div>
      </div>
      <div className="hdr-search">
        <i
          className="bi bi-search"
          style={{ color: "var(--text3)", fontSize: 13 }}
        />
        <input placeholder="Global search…" />
      </div>
      <div style={{ position: "relative" }} ref={notifRef}>
        <div className="hdr-btn" onClick={() => setNotifOpen((o) => !o)}>
          <i className="bi bi-bell" />
          {unread > 0 && <span className="notif-pip" />}
        </div>
        {notifOpen && (
          <NotifPanel
            notifs={notifs}
            onClose={() => setNotifOpen(false)}
            onRead={(id) => {
              onNotifRead(id);
            }}
          />
        )}
      </div>
      <div
        className="hdr-btn"
        title={
          theme === "light" ? "Switch to dark mode" : "Switch to light mode"
        }
        onClick={() => setTheme((t) => (t === "light" ? "dark" : "light"))}
      >
        {theme === "light" ? (
          <i className="bi bi-moon" />
        ) : (
          <i className="bi bi-sun" />
        )}
      </div>
      <div className="hdr-btn" title="Settings" onClick={() => setPage && setPage("account-settings")}>
        <i className="bi bi-gear" />
      </div>
    </div>
  );
}

export default Header;
